import { useCallback, useMemo } from 'react';
import { DataTable } from '~/components/commons/DataTable/DataTable';
import { Box, Switch } from './DataTable.styled';
import { useApi } from '~/components/providers/ApiProvider';
import { useSnackbarContext } from '~/components/providers/SnackbarProvider';

type UsersDataTableProps = {
  data: any;
  orderBy: { id: any; value: any };
  pagination: {
    page: number;
    limit: number;
  };
  onChangePagination: (pg: any) => void;
  onRefresh: () => void;
};

export const UsersDataTable = (props: UsersDataTableProps) => {
  const { clinicsApi } = useApi();
  const snackbar = useSnackbarContext();

  const { data, orderBy, onRefresh } = props;

  const items = useMemo(() => data?.data ?? [], [data]);

  // 유저 - 권한 업데이트
  const handleUpdateUserPermission = useCallback(
    async (userId: number, checked: boolean) => {
      try {
        await clinicsApi.updateUserPermission(userId, checked);
        onRefresh();
        snackbar.success('권한이 변경되었습니다.');
      } catch (error) {
        snackbar.alert('권한 변경을 실패했습니다.');
      }
    },
    [clinicsApi, onRefresh, snackbar]
  );

  const schema = useMemo(
    () => ({
      columns: [
        {
          id: 'no',
          name: 'NO',
          value: (item: any) => item.id || '-',
        },
        {
          id: 'status',
          name: '상태',
          value: (item: any) => {
            return !(item.status == null || item.status === '') ? (
              item.status === 'active' ? (
                <span>사용중</span>
              ) : item.status === 'inactive' ? (
                <span style={{ color: 'red' }}>미사용</span>
              ) : item.status === 'deleted' ? (
                <span style={{ color: 'red' }}>삭제</span>
              ) : (
                <span>-</span>
              )
            ) : (
              <span>-</span>
            );
          },
        },
        {
          id: 'id',
          name: 'ID',
          value: (item: any) => (
            <Box className="id-wrapper">{item.email || '-'}</Box>
          ),
        },
        {
          id: 'name',
          name: '이름',
          value: (item: any) => item.name || '-',
        },
        {
          id: 'position',
          name: '직책',
          value: (item: any) => item.position || '-',
        },
        {
          id: 'certification',
          name: '전자서명 등록 여부',
          value: (item: any) =>
            item.certification === null ? '미등록' : '등록',
        },
        {
          id: 'admin',
          name: '관리자',
          value: (item: any) => (
            <Box className="toggle">
              <Switch
                checked={item.type === 'owner'}
                onChange={(event) =>
                  handleUpdateUserPermission(item.id, event.target.checked)
                }
              />
            </Box>
          ),
        },
      ],
    }),
    [handleUpdateUserPermission]
  );

  return <DataTable data={items} schema={schema} sorts={[orderBy]} resizable />;
};
